import {
  OrderedListOutline,
  BuildOutline,
  BarcodeOutline,
  TruckOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  DashboardOutline,
  SettingOutline,
  UserOutline,
  LockOutline,
  EyeOutline,
  EyeInvisibleOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  MailOutline,
  SolutionOutline,
  LoadingOutline,
  SmileOutline,
  ToolOutline,
  DollarOutline,
  BarChartOutline,
  AlertOutline,
  HistoryOutline,
  TeamOutline,
  LogoutOutline,
  PlusOutline,
  UserAddOutline,
  UserDeleteOutline,
  UsergroupAddOutline,
  AuditOutline,
  FileDoneOutline,
  FileTextOutline,
  CheckCircleOutline,
  LockTwoTone,
  EnvironmentOutline,
  MoreOutline,
  EditOutline,
  DeleteOutline,
  CloseOutline,
  StopOutline,
  InfoCircleOutline,
  UploadOutline,
  SafetyCertificateOutline,
  PhoneOutline,
  CarOutline,
  BankOutline,
  TagOutline,
  IdcardOutline,
  HomeOutline,
  AccountBookOutline,
  ShopOutline,
  ReloadOutline,
  DownloadOutline,
  PauseCircleOutline,
  PlayCircleOutline,
  MinusCircleOutline,
  MinusOutline,
  WarningFill,
  FlagOutline,
  ArrowDownOutline,
  DownOutline,
  LeftOutline,
  RightOutline,
  SearchOutline,
  CheckOutline,
  ExclamationCircleOutline,
  ClockCircleOutline,
  SwapOutline,
  CopyOutline,
  RollbackOutline,
  SelectOutline,
  CalendarOutline,
} from '@ant-design/icons-angular/icons';

import { NZ_ICONS } from 'ng-zorro-antd/icon';

export const icons = [
  OrderedListOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  DashboardOutline,
  FormOutline,
  SettingOutline,
  UserOutline,
  LockOutline,
  EyeOutline,
  EyeInvisibleOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  MailOutline,
  SolutionOutline,
  LoadingOutline,
  SmileOutline,
  ToolOutline,
  DollarOutline,
  BarChartOutline,
  AlertOutline,
  HistoryOutline,
  TeamOutline,
  LogoutOutline,
  PlusOutline,
  UserAddOutline,
  UserDeleteOutline,
  UsergroupAddOutline,
  AuditOutline,
  FileDoneOutline,
  FileTextOutline,
  CheckCircleOutline,
  LockTwoTone,
  EnvironmentOutline,
  MoreOutline,
  EditOutline,
  DeleteOutline,
  CloseOutline,
  StopOutline,
  InfoCircleOutline,
  UploadOutline,
  SafetyCertificateOutline,
  PhoneOutline,
  CarOutline,
  TruckOutline,
  BuildOutline,
  BarcodeOutline,
  BankOutline,
  TagOutline,
  IdcardOutline,
  HomeOutline,
  AccountBookOutline,
  ShopOutline,
  ReloadOutline,
  DownloadOutline,
  PauseCircleOutline,
  PlayCircleOutline,
  MinusCircleOutline,
  MinusOutline,
  WarningFill,
  FlagOutline,
  ArrowDownOutline,
  DownOutline,
  LeftOutline,
  RightOutline,
  SearchOutline,
  CheckOutline,
  ExclamationCircleOutline,
  ClockCircleOutline,
  SwapOutline,
  CopyOutline,
  RollbackOutline,
  SelectOutline,
  CalendarOutline,
];

export function provideNzIcons() {
  return {
    provide: NZ_ICONS,
    useValue: icons,
  };
}
